<template>
  <div class="angel-fund-project-list">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />

    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        :summary-method="summaryMethod"        
        @search-reset="searchResets"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        @row-click="showDetail"
      >
        <template slot="menuLeft">
          <el-button
            size="small"
            plain
            @click="exportShow"
            icon="el-icon-download"
            >导出数据</el-button
          >      
        </template>
        <template slot="investDateSearch">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </template>

        <template slot="fundDetail" slot-scope="{ row }">
          <div class="fund-detail">
            <span v-if="!row['eventNum'] || row['eventNum'] == 0" class="gray-text">暂无</span>
            <span v-else class="blue-text">{{row.eventNum}}个明细</span>
            <a-popover
              placement="right"
              trigger="hover">
              <template slot="content">
                <div class="fund-right-content" >
                  <el-button class="right-btn" type="text" size="small" @click="goAddEvent(0, row)">投资事件-股权投资</el-button>
                  <el-button class="right-btn" type="text" size="small" @click="goAddEvent(1, row)">退出事件-股权退出</el-button>
                  <el-button class="right-btn" type="text" size="small" style="margin-bottom:0 !important;" @click="goAddEvent(2, row)">分红</el-button>
                </div>
              </template>
              <i  class="el-icon-plus plus-right" style="cursor:pointer;"></i>
            </a-popover>
          </div>
        </template>

        <template slot="fundName" slot-scope="{ row }">
          <!-- <div class="project-name" @click="goDetail(row)">{{row.name}}</div> -->
          <div class="project-name" @click="showDetail(row)">{{row.fundName}}</div>
        </template>
      </avue-crud>
    </div>

    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />

    <el-dialog
      :close-on-click-modal="false"
      title="项目详情"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="70%"
    >
        <CommonDetail
          :configArray="formConfig"
          :initValue="detailData"
        >
        </CommonDetail>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false" 
      :title="dialogTitle"
      :visible.sync="dialogVisibles"
      width="75%"
    >
      <InvestEventAdd
        ref="eventAdd"
        :isDetail="isDetail"
        :id="projectId"
        :addType="addType"
        eventBelongType="0"
        :eventId="eventId"
        @addSuccess="addSuccess"
      />
    </el-dialog>    
  </div>
</template>
<script>
import {
  projectConfig,
  detailFormConfig
} from "./config.js";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommonDetail from "@/components/commonDetail/fundCommonDetail";
import Options from "@/components/ShowHidden/showhidden"
import { mapGetters } from "vuex";
import {  getSubFundProjectList, getSubFundProjectDetail, getSubFundProjectListTotal } from "@/api/fund/subfunds"
import InvestEventAdd from "@/components/fundComponent/investEventAdd"
import util from "@/mixins/util"
export default {
  name: 'AngelFundList',
  mixins: [util],
  data() {
    return {
      projectId: '',
      isDetail: false,
      dialogTitle: '',
      eventId: '',
      dialogVisibles: false,
      addType: '',      
      bizType: '2',
      dialogVisible: false,
      examinelist: 0,
      margintap: '0',
      tableData: [],
      selectionList: [],
      detailData: {},
      tableConfig: projectConfig(this.getMoney),
      formConfig: detailFormConfig(this.getMoney),
      searchForm: {},
      dateRange: [],
      totalData: '',
      page: {
          currentPage: 1,
          total: 0,
          layout: "total,pager,prev, next",
          background: false,
          pageSize: 10,
      },   
      disabled:true   
    }
  },
  components: {
    InvestEventAdd,
    CommonSelect,
    CommonDetail,
    Options,
    TagsCloud
  },
  computed: {
    ...mapGetters(["permission","userInfo"]),
    optionColumn() {
      let { column } = projectConfig(this.getMoney)
      return column
    },
  },
  watch: {
    '$route.params': {
      handler(newData, oldData) {
        if(newData.type) {
          this.bizType = newData.type
          this.queryTableData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.bizType = this.$route.params && this.$route.params.type ? this.$route.params.type : '2'
  },
  methods: {
    summaryMethod({ columns, data }) {
      const self = this
      const sums = [];
      let arrays = ['investAmount']
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (arrays.includes(column.property)) {
            // 赋值totalData
            sums[index] = self.getMoney(Math.round(Number(self.totalData[column.property])/10000*100)/100)
          } else {
            sums[index] = "";
          }
        });
      }
      sums[0]="合计:"
      return sums;
    },    
    async showDetail(row) {
      this.detailData = {}
      let res = await getSubFundProjectDetail({id: row.id})
      if(res.data.code == 200) {
        let resData = res.data.data
        resData.industryStr = await this.queryDict(resData.industry, '/api/blade-system/dict-biz/dictionary?code=industry_type_all')
        this.detailData = resData
        this.dialogVisible = true
      }
      // this.$router.push({
      //   path: `/selfFund/projectManage/detail/${row.id}`
      // })
    },

    returnData(data) {
      this.tableConfig.column = data;
    },

    goAddEvent(type, row) {
      // if(row.managerUser!=this.userInfo.user_id){
      //     this.$message({
      //     type: "warning",
      //     message: "您暂无权限进行此操作，请核对是否为其基金对接人。",
      //     });
      //     return
      // }
        this.isDetail = false
        this.dialogTitle = type==0?'新增股权投资':type==1?'新增股权退出':'新增分红'
        this.eventId = ''
        this.projectId = row.id
        this.addType = type
        if(this.$refs.eventAdd){
          this.$refs.eventAdd.cleanData()
        }
        this.dialogVisibles = true
    },

    addSuccess() {
      this.queryTableData()
      this.dialogVisibles = false
    },

    searchChange(query, done) {
      this.page.currentPage = 1;
      this.searchForm = query
      if(this.dateRange != []) {
        this.searchForm.investDateBegin = this.dateRange[0]
        this.searchForm.investDateEnd = this.dateRange[1]
      }
      this.queryTableData()
      done()
    },

    async queryTableData() {
      let params = {
          current: this.page.currentPage,
          size: this.page.pageSize,
          bizType: this.bizType,
          ...this.searchForm
      }
      let res = await getSubFundProjectList(params)
      if(res.data.code == 200) {
        this.tableData = res.data.data.records
        // this.tableData.map(item => {item.fundName = '天使梦想基金'})
        this.page.total = res.data.data.total
        let params = {
          current: this.page.currentPage,
          size: this.page.pageSize,
          bizType: this.bizType,
          ...this.searchForm
        }            
        let totalData = await getSubFundProjectListTotal(params)
        this.totalData = totalData.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    },

    // async queryAuditNum() {
    //   let params = {
    //     current: this.page.currentPage,
    //     size: this.page.pageSize,
    //     ...this.searchForm,
    //     auditState: 1,
    //   }
    //   let res = await getSubFundProjectList(params)
    //   if(res.data.code == 200) {
    //     if(this.margintap == 1){
    //       this.tableData = res.data.data.records
    //       this.tableData.map(item => {item.fundName = '天使梦想基金'})
    //       this.page.total = res.data.data.total
    //       this.examinelist = res.data.data.total
    //       this.tableConfig.selection=false
    //     }else {
    //       this.examinelist = res.data.data.total
    //       this.tableConfig.selection=true
    //     }
    //   }
    // },

    selectionChange(data) {
      this.selectionList = data
    },
    
    // handleAdd() {
    //   this.$router.push({
    //     path: '/fund/angelFund/fundAdd'
    //   })
    // },

    // handleEdit() {
    //   if(this.selectionList.length > 1){
    //     this.$message.error('只能选择一条数据进行编辑')
    //   } else if(this.selectionList.length == 1){
    //     let data = this.selectionList[0]
    //     if(data.auditState == 0) {
    //       // if(data.managerUser == this.userInfo.user_id || data.assistUser == this.userInfo.user_id){
    //         this.$router.push({
    //           path: `/fund/angelFund/detail/${data.id}`
    //         })
    //       // }else {
    //       //   this.$message.warning('您暂无权限对该条数据进行编辑')
    //       // }
    //     }else {
    //       this.$message.warning('该条数据已提交审核无法编辑')
    //     }
    //   }else {
    //     this.$message.error('请选择一条数据进行编辑')
    //   }
    // },

    searchResets() {
        this.searchForm = {}
        this.queryTableData()
    },

    goDetail(data) {
      this.$router.push({
        path: `/fund/angelFund/detail/${data.id}`
      })
    },

    async handleDeletes() {
      let self = this
      let startDelete = () => {
          self.$confirm('确定删除选择的数据?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
              self.deleteData()
          }).catch(() => {
              self.$message({
                  type: 'info',
                  message: '已取消删除'
              });
          });
      }
      if(this.selectionList.length > 1){
          this.$message.error('只能选择一条数据进行删除')
      } else if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        if(data.flowableId != '' && data.auditStatus == 1) {
          // 获取流程数据
          await this.queryFlowData(data.flowableId)
          let presentFlow = this.flowData[this.flowData.length - 1]
          if(this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
            startDelete()
          }else {
            this.$message.error('流程审批中不能删除')
          }
        }else {
          // 直接弹框提示
          startDelete()
        }
      }else{
        this.$message.error('请选择数据进行删除')
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id
      })
      let res = await delProject({ids: ids.join(',')})
      if(res.data.code == 200){
        this.$message.success('删除成功')
        // 刷新列表
        this.queryTableData()
      }
    },

    cloudTages(data) {
      this.files = data;
    },

    exportShow() {
      this.$refs.exportData.showModel();
    }

  }  
}
</script>
<style lang="scss" scoped>
.angel-fund-project-list {
  .blue-text{
    margin-right: 5px;
  }
  /deep/.el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }
  /deep/.el-dialog__body {
    padding: 15px 20px !important;
  }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
    /deep/.el-table__fixed, .el-table__fixed-right {
        height: calc(100% - 0px) !important;
    }
    /deep/.el-table {
      display: flex !important;
      flex-direction: column !important;
    }

    //  order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 
    /deep/.el-table__body-wrapper {
      order: 1 !important;
    }

    /deep/.el-table__fixed-footer-wrapper{
      top: 40px !important;
      z-index: 0;
    }
    /deep/.el-table__fixed-body-wrapper{
      top: 80px !important
    }  
  .radiobut {
    margin: 15px 0;
  }  
  .manage-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name{
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }

  /deep/.el-table .cell, /deep/.el-table th>.cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  /deep/.el-table .cell{
    font-size: 14px;
  }
  .el-table .cell, .el-table th>.cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .el-table .cell{
    font-size: 14px;
  }  
}
/deep/.el-table__footer-wrapper,/deep/.el-table__fixed-footer-wrapper {
   .cell {
      color:red
    }
 }
</style>